import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { getStudentOptions } from '@drivingdoc/api-client/generated/react-query';
import { GetStudentResponse } from 'types/students';

import { PageContainer } from 'components/PageContainer';

import useSearchParamState from 'hooks/useSearchParamState';

import { StudentProfileToolbar } from './components';
import Forms from './Tabs/Forms';
import Ledger from './Tabs/Ledger';
import Progress from './Tabs/Progress';
import Schedule from './Tabs/Schedule';
import StudentInformation from './Tabs/StudentInformation';
import UserActivity from './Tabs/UserActivity';

type StudentProfileTabs = 'info' | 'activity' | 'forms' | 'progress' | 'schedule' | 'ledger';

export function StudentProfile() {
  // get the student id
  const { id } = useParams<{ id: string }>();
  const [tabValue, setTabValue] = useSearchParamState({
    paramName: 'tab',
    initialState: 'info',
    serialize: String,
    deserialize: String,
  });

  // get the student information
  const student = useQuery({
    ...getStudentOptions({
      path: {
        id: id ?? '',
      },
    }),
    enabled: !!id,
  });
  const studentData = student.data as GetStudentResponse | undefined;

  const handleSetTabValue = (_event: React.SyntheticEvent, newValue: StudentProfileTabs) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer
      title={`${studentData?.first_name ?? ''} ${studentData?.middle_name ?? ''} ${studentData?.last_name ?? ''}`}
      slotProps={{
        header: {
          slots: {
            toolbar: () =>
              studentData ? (
                <StudentProfileToolbar
                  userId={studentData.id}
                  isActive={studentData.active}
                  needsOnboarding={studentData.needs_onboarding}
                  onboardingSentAt={studentData.onboarding_sent_at}
                  activatedAt={studentData.activated_at}
                />
              ) : null,
          },
        },
      }}
      // breadcrumbs={[
      //     {
      //         title: 'Title',
      //         path: 'Title'
      //     },
      //     {
      //         title: 'Title',
      //         path: 'Title'
      //     },
      // ]}
    >
      <Tabs
        value={tabValue}
        onChange={handleSetTabValue}
        sx={{
          background: 'transparent',
          ml: -2,
          marginBottom: 2,
        }}
      >
        <Tab value="info" label="Information" />
        <Tab value="activity" label="Activity" />
        <Tab value="forms" label="Forms" />
        <Tab value="progress" label="Progress" />
        <Tab value="schedule" label="Schedule" />
        <Tab value="ledger" label="Ledger" />
      </Tabs>

      {id && tabValue === 'info' && <StudentInformation studentId={id} />}

      {id && tabValue === 'activity' && <UserActivity userId={id} />}

      {id && tabValue === 'forms' && <Forms studentId={id} />}

      {id && tabValue === 'progress' && <Progress studentId={id} />}

      {id && tabValue === 'schedule' && <Schedule studentId={id} />}

      {id && tabValue === 'ledger' && <Ledger studentId={id} />}
    </PageContainer>
  );
}

export default StudentProfile;
